import React from "react";
import Hero from "../components/HomePageComponents/Hero";
import Intro from "../components/HomePageComponents/Intro";
import Services from "../components/HomePageComponents/Services";
import Gallery from "../components/HomePageComponents/Gallery";
import WhyChooseUs from "../components/HomePageComponents/WhyChooseUs";
import Pricing from "../components/HomePageComponents/Pricing";
import HomeShowcase from "../components/HomePageComponents/HomeShowcase";
import Reviews from "../components/ReviewPageComponents/Reviews";

const Home = ({ onBookNow }) => {
  return (
    <>
      <Hero onBookNow={onBookNow} />
      <Intro />
      <HomeShowcase mode="booking" />
      <Pricing />
      <Services />
      <HomeShowcase mode="destinations" />
      <Gallery />
      <WhyChooseUs />
      <Reviews />
    </>
  );
};

export default Home;